import React from "react";
import { NewTab, PageTab } from "../../../../../../components";
import ApprovalFlow from "./TimesheetDetails/ApprovalFlow";
import PayClassification from "./TimesheetDetails/PayClassification";
import TimesheetTasks from "./TimesheetDetails/TimesheetTasks";
import TimesheetDetailsTab from "./TimesheetDetails/TimesheetDetailsTab";
import TimesheetDefaulterNotifiers from "./TimesheetDetails/TimesheetDefaulterNotifiers";
import Others from "./TimesheetDetails/Others";

const TimesheetDetails = ({
  onCancel,
  currentPlacement,
  setActiveTab,
  editData,
}) => {
  const handleBack = () => {
    setActiveTab((prev) => prev + 1);
    // if(onCancel){
    //   onCancel();
    // }
  };
  const TimesheetDetailsMenus = [
    {
      title: "Timesheet Details",
      page: (
        <TimesheetDetailsTab
          currentPlacement={currentPlacement}
          editData={editData}
        />
      ),
      type: "main",
    },
    {
      title: "Approval Flow",
      page: (
        <ApprovalFlow currentPlacement={currentPlacement} editData={editData} />
      ),
      type: "main",
    },
    {
      title: "Pay Classification",
      page: (
        <PayClassification
          currentPlacement={currentPlacement}
          editData={editData}
        />
      ),
      type: "main",
    },
    // {
    //   title: "Timesheet Task(s)",
    //   page: <TimesheetTasks currentPlacement={currentPlacement}/>,
    //   type: "main",
    // },
    {
      title: "Timesheet Defaulter Notifiers",
      page: (
        <TimesheetDefaulterNotifiers
          currentPlacement={currentPlacement}
          handleBack={handleBack}
          editData={editData}
        />
      ),
      type: "main",
    },
    // {
    //   title: "Others",
    //   page: <Others currentPlacement={currentPlacement} handleBack={handleBack}/>,
    //   type: "main",
    // },
  ];
  return (
    <>
      <NewTab
        tabs={TimesheetDetailsMenus}
        color="black"
        variant="text"
        activeVariant="text"
        mode="url"
        tabId="timesheet-details"
      />
    </>
  );
};

export default TimesheetDetails;
